// authReducer.js
import { LOGIN_SUCCESS } from "../auth/authActions";

const initialState = {
  token: localStorage.getItem('token') || null,
  isAuthenticated: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload,
        isAuthenticated: true,

      };
    default:
      return state;
  }
};

export default authReducer;
